import { AfterViewInit, Component, EventEmitter, Output, inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconRegistry, MatIconModule } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { GeneralService } from 'src/app/services/general.service';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlexModule } from '@angular/flex-layout/flex';
import { TourAnchorMatMenuDirective } from 'ngx-ui-tour-md-menu';

@Component({
  selector: 'app-search-form',
  templateUrl: './search-form.component.html',
  styleUrls: ['./search-form.component.scss'],
  standalone: true,
  imports: [TourAnchorMatMenuDirective, FlexModule, MatTooltipModule, MatSlideToggleModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule, MatSelectModule, MatOptionModule]
})
export class SearchFormComponent implements AfterViewInit {
  formGroup!: FormGroup;
  private matIconRegistry = inject(MatIconRegistry);
  private domSanitizer = inject(DomSanitizer);
  private generalService = inject(GeneralService);
  private router = inject(Router);
  panelOpenState = false;
  checked: boolean = false;
  searchResults: any = [];
  countryList: any = []
  isExostarSupplier: boolean = true;
  ispanel: boolean = true;
  showWindow = true;
  inviteSupplier = false;
  inviteDisbleFlag = false;
  isInviteSupplierDisabled: any;
  @Output() requestParams = new EventEmitter<any>();
  @Output() inviteOption = new EventEmitter<any>();
  tourService: any;
  requestData: any = {};
  constructor(
  ) {
    const formBuilder = inject(FormBuilder);
    this.requestData = this.generalService.getSearchRequestParams();
    this.formGroup = formBuilder.group({
      name: [this.requestData?.name, ''],
      dunsNumber: [this.requestData?.dunsNumber, ''],
      exostarId: [this.requestData?.exostarId, ''],
      usTaxId: [this.requestData?.usTaxId, ''],
      address1: [this.requestData?.address1, ''],
      address2: [this.requestData?.address2, ''],
      city: [this.requestData?.city, ''],
      state: [this.requestData?.state, ''],
      zip: [this.requestData?.zip, ''],
      country: [this.requestData?.country, ''],
    }, { validator: this.atLeastOneRequiredValidator },
    );

    this.matIconRegistry.addSvgIcon(
      "down",
      this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/icons/Down.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "right",
      this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/icons/Right.svg"),
    );
  }
  ngAfterViewInit(): void {
    this.requestData = this.generalService.getSearchRequestParams();
    this.formGroup.patchValue({
      name: this.requestData?.name || '',
      dunsNumber: this.requestData?.dunsNumber || '',
      exostarId: this.requestData?.exostarId || '',
      usTaxId: this.requestData?.usTaxId || '',
      address1: this.requestData?.address1 || '',
      address2: this.requestData?.address2 || '',
      city: this.requestData?.city || '',
      state: this.requestData?.state || '',
      zip: this.requestData?.zip || '',
      country: this.requestData?.country || '',
    });
  }

  ngOnInit(): void {
    this.generalService.getCountryDetails().subscribe((countryResults) => {
      this.countryList = countryResults;
    })

    if (this.router.parseUrl(this.router.url).queryParams['shouldToggle']) {
      this.isExostarSupplier = false;
    } else {
      this.isExostarSupplier = true;
    }
    this.generalService.getBuyerFeatureList().subscribe((data: any) => {

      if (!this.requestData?.isExostarSupplier && !data.InviteOrg) {
        this.isExostarSupplier = false;
      }
      if (this.requestData?.isExostarSupplier) {
        this.isExostarSupplier = true;
      }
      this.isInviteSupplierDisabled = data.InviteOrg;
      this.generalService.setInviteSupplierValue(this.isExostarSupplier == this.isInviteSupplierDisabled);
    })

    this.requestData = this.generalService.getSearchRequestParams();
    if (Object.keys(this.requestData || {}).length) {
      this.formGroup.patchValue({
        name: this.requestData.name,
        dunsNumber: this.requestData.dunsNumber,
        exostarId: this.requestData.exostarId,
        usTaxId: this.requestData.usTaxId,
        address1: this.requestData.address1,
        address2: this.requestData.address2,
        city: this.requestData.city,
        state: this.requestData.state,
        zip: this.requestData.zip,
        country: this.requestData.country,
      });
    }
  }
  atLeastOneRequiredValidator(group: FormGroup) {
    const controls = ['name', 'dunsNumber', 'exostarId', 'usTaxId'];

    const filledFields = controls.filter((controlName) =>
      group.get(controlName)?.value !== null && group.get(controlName)?.value !== ''
    );

    return filledFields.length > 0 ? null : { atLeastOneRequired: true };
  }

  toggleChange() {
    this.isExostarSupplier = !this.isExostarSupplier;
    this.generalService.setInviteSupplierValue(this.isExostarSupplier == this.isInviteSupplierDisabled)
    this.inviteOption.emit(this.requestData);
    this.generalService.selectedSupplierNumbers.next([]);
  }

  expansionPanel() {
    this.ispanel = !this.ispanel;
  }
  onSubmit() {
    this.requestParams.emit({
      ...this.formGroup.value,
      isExostarSupplier: this.isExostarSupplier
    });
    this.generalService.setSearchRequestParams({
      ...this.formGroup.value,
      isExostarSupplier: this.isExostarSupplier
    })
  }

}
